import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import clinicAPI from "../../../services/clinicApi";
import { sortClubLifeFeedPosts } from "../../../utils/clubLifeFeedSort";
import { CLUB_LIFE_FEED_FILTERS } from "../../../constants/clubLifeCategories";
import ClubLifePostCard from "../common/ClubLifePostCard";
import ClientPostManageModals from "./ClientPostManageModals";
import { useClubLifeInteractions } from "../../../hooks/useClubLifeInteractions";
import { useClientPostManage } from "../../../hooks/useClientPostManage";
import s from "../clinic.module.css";
import { EmptyState, Chip, ChipGroup } from "../../ui";

export default function ClubLifeFeed() {
  const myId = useSelector((state) => state.auth.profile?.id);
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState("all");
  const [loading, setLoading] = useState(true);

  const {
    commentBusy,
    openComments,
    commentsByPost,
    toggleLike,
    loadComments,
    addComment,
  } = useClubLifeInteractions(setPosts);
  const postManage = useClientPostManage(setPosts);

  const load = useCallback(async () => {
    try {
      const data = await clinicAPI.getClubLifeFeed({
        category: category === "all" ? undefined : category,
      });
      setPosts(sortClubLifeFeedPosts(data.posts || []));
    } catch {
      setPosts([]);
    } finally {
      setLoading(false);
    }
  }, [category]);

  useEffect(() => {
    setLoading(true);
    load();
  }, [load]);

  return (
    <>
    <div className={s.clubLifeHub}>
      <ChipGroup className={s.clubLifeFilters} label="Категории">
        {CLUB_LIFE_FEED_FILTERS.map((c) => (
          <Chip
            key={c.id}
            selected={category === c.id}
            onClick={() => setCategory(c.id)}
          >
            {c.icon} {c.label}
          </Chip>
        ))}
      </ChipGroup>

      {loading ? (
        <p className={s.pollsEditorIntro}>Загрузка…</p>
      ) : posts.length === 0 ? (
        <EmptyState
          title="Пока нет публикаций"
          description="Тренер скоро поделится новостями и фото с тренировок."
        />
      ) : (
        <div className={s.clubLifeFeed}>
          {posts.map((post) => (
            <ClubLifePostCard
              key={post.id}
              post={post}
              mode="client"
              currentUserId={myId}
              onOpenMenu={postManage.openMenu}
              onLike={toggleLike}
              onLoadComments={loadComments}
              commentsOpen={openComments === post.id}
              comments={commentsByPost[post.id] || []}
              onComment={addComment}
              commentBusy={commentBusy}
            />
          ))}
        </div>
      )}
    </div>
    <ClientPostManageModals {...postManage} allowCategory />
    </>
  );
}
